function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { SelectRoleOrPerson } from "./SelectRoleOrMemberModal/SelectRoleOrPerson";
import cx from 'classnames';
import React, { useContext, useState } from 'react';
import { PeopleRoleSelectContext } from "./context";
import "./index.css";
var PeopleRoleSelectContent = function PeopleRoleSelectContent(props) {
  var selectWidth = props.selectWidth;
  var PeopleRoleSelectContextProps = useContext(PeopleRoleSelectContext);
  var mode = PeopleRoleSelectContextProps.mode,
    memberNodes = PeopleRoleSelectContextProps.memberNodes,
    groupNodes = PeopleRoleSelectContextProps.groupNodes,
    changeNodes = PeopleRoleSelectContextProps.changeNodes;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchValue = _useState4[0],
    setSearchValue = _useState4[1];
  return /*#__PURE__*/React.createElement("div", {
    className: cx(mode === 'select' ? 'in-select' : 'in-modal', 'dr-people-role-select-popup-content'),
    style: {
      width: typeof selectWidth === 'number' ? selectWidth : 'auto'
    }
  }, /*#__PURE__*/React.createElement(SelectRoleOrPerson, {
    haveRightSide: mode === 'modal',
    groupNodes: groupNodes,
    setGroupNodes: function setGroupNodes(tempGroupNodes) {
      changeNodes('groups', tempGroupNodes);
    },
    memberNodes: memberNodes,
    setMemberNodes: function setMemberNodes(tempMemberNodes) {
      changeNodes('member', tempMemberNodes);
      // onChange?.(
      //   groupNodes
      //     .map((item) => ({
      //       id: item.id,
      //       name: item.name,
      //     }))
      //     .concat(tempMemberNodes.map((item) => ({ id: item.id, name: item.completeName }))),
      // );
    },
    value: value,
    onChange: function onChange(tempValue) {
      setValue(tempValue);
    },
    searchValue: searchValue,
    onChangeSearchValue: function onChangeSearchValue(tempValue) {
      return setSearchValue(tempValue);
    }
  }));
};
export default PeopleRoleSelectContent;